"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const react_core_1 = require("@patternfly/react-core");
const DeleteCustomManifestModal = ({ isOpen, onClose, onDelete, }) => (React.createElement(react_core_1.Modal, { title: 'Remove custom manifests', isOpen: isOpen, onClose: onClose, variant: react_core_1.ModalVariant.small, actions: [
        React.createElement(react_core_1.Button, { "data-testid": "delete-manifest-submit", key: "confirm", variant: "danger", onClick: onDelete },
            'Remove',
            ' '),
        React.createElement(react_core_1.Button, { key: "cancel", variant: "link", onClick: onClose }, "Cancel"),
    ] }, 'All the data entered for custom manifests will be lost and there will not be any custom manifests included in the installation.'));
exports.default = DeleteCustomManifestModal;
//# sourceMappingURL=DeleteCustomManifestModal.js.map